import { createSlice } from '@reduxjs/toolkit';

export const filterSlice = createSlice({
    name: 'filter',
    initialState: {
        skip: 0,
        find: '',
        mode: 'grid',
        where: 'index', // дефолтная область поиска (по текстовому индексу)
        categories: [],
        countries: [],
        dates: [],
    },
    reducers: {
        filterReset: (state, action) => {
            state.skip = 0;
            state.find = '';
            state.where = 'index';
            state.countries = [];
            state.categories = [];
            state.dates = [];
        },
        filterSwitch: (state, action) => {
            // При переключении вывода между экспонентами и активностями
            state.skip = 0;
            state.find = '';
            state.where = 'index';
        },
        skipSet: (state, action) => {
            state.skip = action.payload;
        },
        findSet: (state, action) => {
            state.find = action.payload;
        },
        modeSet: (state, action) => {
            state.mode = action.payload;
        },
        whereSet: (state, action) => {
            state.where = action.payload;
        },
        categorySet: (state, action) => {
            let index = state.categories.indexOf(action.payload);
            if(index < 0) {
                state.categories.push(action.payload);
            }
        },
        categoryUnset: (state, action) => {
            let index = state.categories.indexOf(action.payload);
            if(index >= 0) {
                state.categories.splice(index, 1);
            }
        },
        categorySwitch: (state, action) => {
            let index = state.categories.indexOf(action.payload);
            if(index < 0) {
                state.categories.push(action.payload);
            } else {
                state.categories.splice(index, 1);
            }
        },
        categoriesClear: (state, action) => {
            state.categories = [];
        },
        countrySet: (state, action) => {
            let index = state.countries.indexOf(action.payload);
            if(index < 0) {
                state.countries.push(action.payload);
            }
        },
        countryUnset: (state, action) => {
            let index = state.countries.indexOf(action.payload);
            if(index >= 0) {
                state.countries.splice(index, 1);
            }
        },
        countrySwitch: (state, action) => {
            let index = state.countries.indexOf(action.payload);
            if(index < 0) {
                state.countries.push(action.payload);
            } else {
                state.countries.splice(index, 1);
            }
        },
        countriesClear: (state, action) => {
            state.countries = [];
        },
        dateSet: (state, action) => {
            let index = state.dates.indexOf(action.payload);
            if(index < 0) {
                state.dates.push(action.payload);
            }
        },
        dateUnset: (state, action) => {
            let index = state.dates.indexOf(action.payload);
            if(index >= 0) {
                state.dates.splice(index, 1);
            }
        },
        dateSwitch: (state, action) => {
            let index = state.dates.indexOf(action.payload);
            if(index < 0) {
                state.dates.push(action.payload);
            } else {
                state.dates.splice(index, 1);
            }
        },
        datesClear: (state, action) => {
            state.dates = [];
        },
    }
});

export const {
    filterReset,
    filterSwitch,
    skipSet,
    findSet,
    modeSet,
    whereSet,
    categorySet,
    categoryUnset,
    categorySwitch,
    categoriesClear,
    countrySet,
    countryUnset,
    countrySwitch,
    countriesClear,
    dateSet,
    dateUnset,
    dateSwitch,
    datesClear,
} = filterSlice.actions;
export default filterSlice.reducer;
